import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Aerolineas_Title } from '../../../../../utils/EN/Modals/CorpModals';

const ModalCorpAerolineas = () => {
  return (
    <>
      <ModalVideo
        id="corporate-aerolineas"
        dataText={Aerolineas_Title}
        videoSrc="https://player.vimeo.com/video/126559903?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_AEROLINEAS"
      />
    </>
  );
};

export default ModalCorpAerolineas;
